import Text from 'components/Text/Text';
import React, { useContext } from 'react';
import Button from 'components/Button/Button';
import breadcrumbs from 'images/breadcrumbs.svg';
import {
	ChangeModifierPositionContext,
	IChangeModifierPositionContext,
} from '../../../../../changeModifierPositionState/changeModifierPositionContext';
import classNames from 'classnames';
import style from './ResetBtn.module.scss';

const ResetBtn: React.FC = () => {
	const { resetSelectedControls, IDSelectedCustomer, IDSelectedRestaurant, IDSelectedModifierGroup } =
		useContext<IChangeModifierPositionContext>(ChangeModifierPositionContext);

	const resetBtnClasses = classNames(style.resetBtn, {
		[style.active]: IDSelectedCustomer || IDSelectedRestaurant || IDSelectedModifierGroup,
	});

	return (
		<Button
			className={resetBtnClasses}
			theme="secondary"
			onClick={resetSelectedControls}
			icon={
				<svg className={style.icon}>
					<use xlinkHref={`${breadcrumbs}#resetIcon`} />
				</svg>
			}
			data-test="ResetBtn">
			<Text translationNameSpace="listing" translationKey="resetButton" asFragment={true} />
		</Button>
	);
};

export default ResetBtn;
